import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Seo from "@/components/seo/Seo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { authService } from "@/api/services";
import { toast } from "sonner";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const token = params.get("token") || "";
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!token) {
            toast.error("Missing reset token");
            return;
        }
        if (password.length < 8) {
            toast.error("Password must be at least 8 characters");
            return;
        }
        setSubmitting(true);
        try {
            await authService.resetPassword(token, password);
            toast.success("Password reset. You can now log in.");
            navigate("/login");
        } catch (err) {
            toast.error(err?.message || "Reset failed");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Layout withFooter={false}>
            <Seo title="Reset Password" path="/reset-password" noIndex />
            <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4">
                <div className="w-full max-w-md">
                    <h1 className="text-3xl font-black uppercase tracking-tighter text-center mb-6">
                        Reset password
                    </h1>
                    <form
                        onSubmit={onSubmit}
                        className="bg-card border border-border p-8 space-y-5"
                        data-testid="reset-form"
                    >
                        <div className="space-y-2">
                            <Label htmlFor="password" className="font-mono text-xs uppercase tracking-widest text-zinc-400">
                                New Password
                            </Label>
                            <Input
                                id="password"
                                type="password"
                                required
                                minLength={8}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="rounded-none bg-background border-border focus:border-primary focus:ring-1 focus:ring-primary"
                                data-testid="reset-password-input"
                            />
                        </div>
                        <Button
                            type="submit"
                            disabled={submitting}
                            className="w-full rounded-none bg-primary text-primary-foreground hover:bg-[#33FFB0] font-bold uppercase tracking-wider h-11"
                            data-testid="reset-submit-btn"
                        >
                            {submitting ? "Updating..." : "Update password"}
                        </Button>
                        <div className="text-center text-xs font-mono uppercase tracking-widest pt-2">
                            <Link to="/login" className="text-primary">
                                ← Back to login
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
        </Layout>
    );
}
